import { GetServerSideProps } from 'next'
import Location from '@components/Location'
import getLocations from '@components/Location/server/getLocations'
import { LocationProps } from '@components/Location/location.types'
import getZipCodePosition from '@components/Location/server/getZipCodePosition'
import normalizeQuery from '@utilities/functions/normalizeQuery'
import MainLayout from '@components/MainLayout/MainLayout'
import getServerSideAccessToken from '@utilities/auth/server/getServerSideAccessToken'
import bidapi from '../../api/bidapi'
import { formatPrefZipcodeUrl } from '../../contexts/NavigationContext/utils'

const baseUrl = `${process.env.NEXT_PUBLIC_AUCTION_API}`

export const getServerSideProps: GetServerSideProps<LocationProps> = async (
  context: any
) => {
  const { query, resolvedUrl } = context

  const token = await getServerSideAccessToken(context)

  if (token && !query.zipCode) {
    const { preferredZipcode } = await bidapi({
      url: `${baseUrl}/bidder/get`,
      context,
      token,
    })

    if (preferredZipcode)
      return {
        redirect: {
          destination: formatPrefZipcodeUrl(preferredZipcode, resolvedUrl),
          permanent: false,
        },
      }
  }

  const zipCode = normalizeQuery(query.zipCode)
  const { allLocations, locationsInArea } = await getLocations(zipCode)
  const zipCodePosition = await getZipCodePosition(context)

  return { props: { allLocations, locationsInArea, zipCodePosition, zipCode } }
}

const LocationPage = (props: LocationProps) => {
  return (
    <MainLayout
      title="BidFTA Online Auction Locations"
      previewDescription="Are you ready to find an online auction near you? Visit our auction pick up center locator to find a BidFTA near you."
    >
      <Location {...props} />
    </MainLayout>
  )
}

export default LocationPage
